import { WarningOutlined } from "@ant-design/icons";
import { Input as AntdInput } from "antd";
import cx from "classnames";
import { useField } from "formik";
import { useEffect, useState } from "react";

import styles from "./Input.module.css";
import { useTranslation } from "react-i18next";

const Input = ({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  onChange = () => { },
  className = "",
  subclassName = "",
  required = false,
  disabled = false,
  useTimeout = null,
  autoSize = false,
  autoComplete = "",
  onKeyDown = () => { },
  rows = "8",
  readOnly = false,
  regex = '',
  formRegex = false,
  onPaste = () => { }
}) => {
  const { i18n } = useTranslation();
  const [timeoutId, setTimeoutId] = useState(null);
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value, error, touched } = meta;
  const { setValue } = helpers;

  const handleChange = (e) => {
    let value;
    if (regex && formRegex) {
      if (regex.test(e.target.value)) {
        value = e.target.value;
        onChange(value)
      } else {
        onChange('')
        return;
      }
    } else {
      value = e.target.value
    }
    setValue(value);
    if (useTimeout) {
      if (timeoutId) clearTimeout(timeoutId);
      setTimeoutId(
        setTimeout(() => {
          onChange(value);
        }, useTimeout)
      );
    } else {
      onChange(value);
    }
  };

  const translatedError =
    touched && error
      ? i18n.language === "th"
        ? `กรุณากรอก ${label}`
        : `Please enter ${label.toLowerCase()}`
      : "";

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      {type === "password" ? (
        <AntdInput.Password
          id={name}
          readOnly={readOnly}
          className={cx(styles.input, subclassName)}
          name={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && error ? "error" : ""}
          status={touched && error ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          autoComplete={autoComplete}
        />
      ) : type === "text" ? (
        <AntdInput
          id={name}
          className={cx(styles.input, subclassName)}
          readOnly={readOnly}
          name={name}
          placeholder={placeholder}
          type={type}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && error ? "error" : ""}
          status={touched && error ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          autoComplete={autoComplete}
          onKeyDown={onKeyDown}
          onPaste={onPaste}
        />
      ) : (
        <AntdInput.TextArea
          rows={rows}
          readOnly={readOnly}
          autoSize={autoSize}
          id={name}
          className={cx(styles.input, subclassName)}
          name={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && error ? "error" : ""}
          status={touched && error ? "error" : ""}
          disabled={disabled}
          size={size}
          autoComplete={autoComplete}
          onKeyDown={onKeyDown}
        />
      )}

      {translatedError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {translatedError}
        </span>
      )}
    </div>
  );
};

export default Input;
